exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?minimize!ekko-lightbox/dist/ekko-lightbox.css"), "");

// module
exports.push([module.id, "[data-toggle=lightbox][data-gallery=photo-gallery] .img-thumbnail{-webkit-box-shadow:0 0;box-shadow:0 0;-webkit-transition:-webkit-box-shadow .2s ease-in-out;transition:-webkit-box-shadow .2s ease-in-out;transition:box-shadow .2s ease-in-out;transition:box-shadow .2s ease-in-out,-webkit-box-shadow .2s ease-in-out}[data-toggle=lightbox][data-gallery=photo-gallery]:hover .img-thumbnail{-webkit-box-shadow:0 0 34px 4px hsla(0,0%,100%,.5);box-shadow:0 0 34px 4px hsla(0,0%,100%,.5)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-520be934","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/PhotoGallery.vue
// module id = Bbx0
// module chunks = 1